import { EventDates, EventDatesPartial } from '../types';

export enum LegendAction {
  DecrementSteps = 'DECREMENT_STEPS',
  EditLegend = 'EDIT_LEGEND',
  EditLegendFailure = 'EDIT_LEGEND_FAILURE',
  IncrementSteps = 'INCREMENT_STEPS',
  ReceiveEditLegend = 'RECEIVE_EDIT_LEGEND',
  ReceiveLegend = 'RECEIVE_LEGEND',
  RequestLegend = 'REQUEST_LEGEND',
  SetMaxValue = 'SET_MAX_VALUE',
  SetMinValue = 'SET_MIN_VALUE',
  SetSteps = 'SET_STEPS',
  ToggleEditLegend = 'TOGGLE_EDIT_LEGEND',
}

export interface DecrementStepsAction {
  type: LegendAction.DecrementSteps;
}

export function decrementSteps(): DecrementStepsAction {
  return {
    type: LegendAction.DecrementSteps,
  };
}

export interface EditLegendFailureAction {
  type: LegendAction.EditLegendFailure;
}

export function editLegendFailure() {
  return {
    type: LegendAction.EditLegendFailure,
  };
}

export interface EditLegendValuesAction {
  type: LegendAction.EditLegend;
  crop: string;
  dates: EventDates
  fieldUuid: string;
  layer: string;
  legendValues: unknown;
  season: string;
  subLayer?: string
  username: string;
  year: unknown;
  userUuid: string;
}

export function editLegendValues(
  legendValues: unknown,
  username: string,
  uuid: string,
  year: unknown,
  crop: string,
  layer: string,
  season: string,
  subLayer: string | undefined,
  dates: EventDates,
  userUuid: string
): EditLegendValuesAction {
  return {
    type: LegendAction.EditLegend,
    crop,
    dates,
    fieldUuid: uuid,
    layer,
    legendValues,
    season,
    subLayer,
    username,
    year,
    userUuid
  };
}

export interface IncrementStepsAction {
  type: LegendAction.IncrementSteps;
}

export function incrementSteps() {
  return {
    type: LegendAction.IncrementSteps,
  };
}

export interface ReceiveEditLegendAction {
  type: LegendAction.ReceiveEditLegend,
  [key: string]: unknown;
}

export function receiveEditLegend(payload: object): ReceiveEditLegendAction {
  return {
    type: LegendAction.ReceiveEditLegend,
    ...payload,
  };
}

export interface LegendPayload {
  b: number;
  g: number;
  r: number;
  stringValue?: string;
  units?: string;
  value?: number;
}

export interface ReceiveLegendAction {
  type: LegendAction.ReceiveLegend;
  legend: LegendPayload[];
  layer: string;
  season: string;
  subLayer?: string;
}

export function receiveLegend(
  legend: LegendPayload[],
  layer: string,
  season: string,
  subLayer?: string
): ReceiveLegendAction {
  return {
    type: LegendAction.ReceiveLegend,
    legend,
    layer,
    season,
    subLayer,
  };
}

export interface RequestLegendAction {
  type: LegendAction.RequestLegend,
  username: string;
  fieldUuid: string;
  dates: EventDatesPartial;
  crop?: string;
  layer: string;
  season: string;
  subLayer?: string;
  userUuid: string;
}

export function reqLegend(
  username: string,
  fieldUuid: string,
  dates: EventDatesPartial,
  crop: string | undefined,
  layer: string,
  season: string,
  subLayer: string | undefined,
  userUuid: string
): RequestLegendAction {
  return {
    type: LegendAction.RequestLegend,
    username,
    fieldUuid,
    dates,
    crop,
    layer,
    season,
    subLayer,
    userUuid
  };
}

export interface SetMaxValueAction {
  type: LegendAction.SetMaxValue;
  value: number;
}

export function setMaxValue(value: number): SetMaxValueAction {
  return {
    type: LegendAction.SetMaxValue,
    value,
  };
}

export interface SetMinValueAction {
  type: LegendAction.SetMinValue;
  value: number;
}

export function setMinValue(value: number): SetMinValueAction {
  return {
    type: LegendAction.SetMinValue,
    value,
  };
}

export interface SetStesAction {
  type: LegendAction.SetSteps;
  value: number;
}

export function setSteps(value: number): SetStesAction {
  return {
    type: LegendAction.SetSteps,
    value,
  };
}

export interface ToggleEditLegendAction {
  type: LegendAction.ToggleEditLegend;
  index: number;
}

export function toggleEditLegend(index: number): ToggleEditLegendAction {
  return {
    type: LegendAction.ToggleEditLegend,
    index,
  };
}

export type LegendActions = RequestLegendAction
  | SetMinValueAction
  | SetStesAction
  | ToggleEditLegendAction
  | SetMaxValueAction
  | ReceiveLegendAction
  | ReceiveEditLegendAction
  | IncrementStepsAction
  | DecrementStepsAction
  | EditLegendFailureAction
  | EditLegendValuesAction;